import { GlButton, GlLabel, GlPopover } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { visitUrl } from '~/lib/utils/url_utility';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { ROUTE_EDIT_FRAMEWORK, ROUTE_FRAMEWORKS } from '../../constants';
export default {
    name: 'ComplianceFrameworkBadge',
    components: {
        GlLabel,
        GlButton,
        GlPopover
    },
    inject: {
        namespaceId: {
            default: null
        }
    },
    props: {
        framework: {
            type: Object,
            required: true
        },
        showDefault: {
            type: Boolean,
            required: false,
            default: true
        },
        closeable: {
            type: Boolean,
            required: false,
            default: false
        },
        popoverMode: {
            type: String,
            required: true,
            validator: (value)=>[
                    'details',
                    'hidden',
                    'edit',
                    'disabled'
                ].includes(value)
        },
        viewDetailsUrl: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'close'
    ],
    computed: {
        showDefaultBadge () {
            return this.showDefault && this.framework.default;
        },
        isEditMode () {
            return this.popoverMode === 'edit';
        },
        isDisabled () {
            return this.popoverMode === 'disabled';
        },
        showPopover () {
            return this.popoverMode !== 'hidden';
        },
        isCSPFramework () {
            if (!this.framework.namespaceId || !this.namespaceId) {
                return false;
            }
            return getIdFromGraphQLId(this.framework.namespaceId) !== getIdFromGraphQLId(this.namespaceId);
        },
        frameworkName () {
            const maxLength = 30;
            const name = this.framework?.name?.length > maxLength ? `${this.framework.name.substring(0, maxLength)}...` : this.framework.name;
            return this.showDefaultBadge ? `${name} (${this.$options.i18n.default})` : name;
        },
        frameworkTestId () {
            return this.showDefaultBadge ? 'compliance-framework-default-label' : 'compliance-framework-label';
        },
        frameworkId () {
            return getIdFromGraphQLId(this.framework.id);
        }
    },
    methods: {
        editFromPopover () {
            this.$router.push({
                name: ROUTE_EDIT_FRAMEWORK,
                params: {
                    id: this.frameworkId
                }
            });
        },
        viewFrameworkDetails () {
            if (this.viewDetailsUrl) {
                visitUrl(this.viewDetailsUrl);
            } else {
                this.$router.push({
                    name: ROUTE_FRAMEWORKS,
                    query: {
                        id: this.frameworkId
                    }
                });
            }
        }
    },
    i18n: {
        default: s__('ComplianceFrameworks|default'),
        edit: s__('ComplianceReport|Edit the framework'),
        viewDetails: s__('ComplianceReport|View the framework details'),
        disabledText: s__('ComplianceReport|Only group owners and maintainers can view the framework details'),
        CSPFramework: s__('ComplianceFramework|Instance level compliance framework')
    }
};
